import { ThumbUp } from "@livechat/design-system-icons";

import { RatingFilter, RatingFilterFormattedValues } from "constants/filters";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

export const ratingFilterConfig: IFilterConfig = {
  title: "Rating",
  icon: ThumbUp,
  mobileViewTitle: "Select rating",
  multiple: true,
  getFilterLabelValues: (filterValues: RatingFilter[] | null): IFilterLabelValue[] => {
    if (filterValues === null) {
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IFilterLabe... Remove this comment to see the full error message
      return null;
    }

    return filterValues.map((filterValue: string) => ({
      key: filterValue,
      // @ts-expect-error TS(7053)
      label: RatingFilterFormattedValues[filterValue],
    }));
  },
  filterLabels: Object.entries(RatingFilterFormattedValues).map(([value, label]) => ({ value, label })),
};
